import styled from 'styled-components';

export const Lottie = styled.div``;